'use strict';

module.exports = {
    print: () => {
        window.print();
    }
};
